import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase"; // ඔබේ firebase.js එකෙන් db එක import කරගන්න
import "./WorksPage.css";

const LazyImage = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="wp-image-wrapper">
      {!loaded && <div className="wp-image-skeleton" />}

      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={`wp-album-masonry-image ${
          loaded ? "loaded" : ""
        }`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

const WorksPage = () => {
  const navigate = useNavigate();
  const masonryRef = useRef(null);

  const [categories, setCategories] = useState([
    {
      id: "latest",
      name: "LATEST",
      active: true,
    },
    {
      id: "portraits",
      name: "PORTRAITS",
      active: false,
    },
    {
      id: "wedding",
      name: "WEDDING",
      active: false,
    },
    {
      id: "editorial",
      name: "EDITORIAL",
      active: false,
    },
    {
      id: "commercial",
      name: "COMMERCIAL",
      active: false,
    },
    
  ]);

  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 640) {
        setColumns(1);
      } else if (width < 1024) {
        setColumns(2);
      } else {
        setColumns(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getFallbackImage = (category) =>
    `https://source.unsplash.com/random/800x600/?photography,${category}`;

  // 🔥 Firebase Firestore එකෙන් අදාළ Category එකට අදාළ Albums Fetch කරගැනීම
  useEffect(() => {
    const fetchAlbumsFromFirestore = async () => {
      setLoading(true);

      try {
        const activeCategory = categories.find((c) => c.active);
        if (!activeCategory) return;

        // categorized_albums collection එකෙන් අදාළ category එක query කිරීම
        const q = query(
          collection(db, "categorized_albums"),
          where("category", "==", activeCategory.id)
        );

        const querySnapshot = await getDocs(q);
        const albumData = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          albumData.push({
            id: doc.id,
            folderName: doc.id, // අවශ්‍ය නම් document ID එක හෝ album name එක පාවිච්චි කරන්න පුළුවන්
            name: data.albumName,
            coverImage: data.images && data.images.length > 0 
              ? data.images[0] 
              : getFallbackImage(activeCategory.id),
            imageCount: data.images ? data.images.length : 0,
            categoryId: activeCategory.id,
            images: data.images || [] // ඇතුලේ තියෙන සියලුම image URLs
          });
        });

        setAlbums(albumData);
      } catch (err) {
        console.error("Error fetching albums: ", err);
        setAlbums([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAlbumsFromFirestore();
  }, [categories]);

  const handleCategorySelect = (id) => {
    setCategories((prev) =>
      prev.map((cat) => ({
        ...cat,
        active: cat.id === id,
      }))
    );
  };

  const openAlbum = (album) => {
    navigate(
      `/gallery/${album.categoryId}/${album.folderName}`
    );
  };

  const splitIntoColumns = (items, cols) => {
    const result = Array.from(
      { length: cols },
      () => []
    );

    items.forEach((item, index) => {
      result[index % cols].push(item);
    });

    return result;
  };

  const albumColumns = splitIntoColumns(albums, columns);

  return (
    <div className="wp-container">
      <header className="wp-header">
        <div className="wp-header-content">
          <nav className="wp-categories-nav mobile-scroll">
            <ul>
              {categories.map((cat) => (
                <li key={cat.id}>
                  <button
                    className={`wp-category-btn ${
                      cat.active ? "active" : ""
                    }`}
                    onClick={() => handleCategorySelect(cat.id)}
                    disabled={loading}
                  >
                    {cat.name}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>

      <main className="wp-content">
        {loading ? (
          <div className="wp-masonry-grid-container">
            <div
              className="wp-masonry-grid"
              style={{
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
              }}
            >
              {Array.from({ length: 9 }).map((_, index) => (
                <div
                  key={index}
                  className="wp-album-skeleton"
                />
              ))}
            </div>
          </div>
        ) : albums.length === 0 ? (
          <p style={{ textAlign: "center", padding: "50px 0" }}>
            No albums found
          </p>
        ) : (
          <div className="wp-masonry-grid-container">
            <div
              className="wp-masonry-grid"
              style={{
                gridTemplateColumns: `repeat(${columns},1fr)`,
              }}
              ref={masonryRef}
            >
              {albumColumns.map((column, columnIndex) => (
                <div
                  key={columnIndex}
                  className="wp-masonry-column"
                >
                  {column.map((album) => (
                    <div
                      key={album.id}
                      className="wp-album-masonry-card enhanced"
                      onClick={() => openAlbum(album)}
                    >
                      <div className="wp-album-masonry-cover">
                        <LazyImage
                          src={album.coverImage}
                          alt={album.name}
                        />
                      </div>

                      <div className="wp-album-masonry-overlay">
                        <div className="wp-album-overlay-inner">
                          <h4 className="wp-album-masonry-name">
                            {album.name}
                          </h4>

                          <span className="wp-album-image-count">
                            {album.imageCount} photos
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default WorksPage;